<template>
    <div>
        <Tabs
            v-if="loaded"
            :data="data"
            ref="Tabs"
        />
    </div>
</template>

<script>
// Components.
import Tabs from './Tabs'

// Others.
import { mapActions } from 'vuex'
import { object, stringCase, repository, error } from '@/mixins'

export default {
    components: { Tabs },
    created() {

        this.repositories = {
            parametrizacao: this.getConectaSusRepository('almoxarifado.parametrizacao'),
        }

        this.load()
    },
    data: () => ({
        data: null,
        loaded: false,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            this.repositories.parametrizacao.create()
                .then(({ data }) => {

                    this.data = data

                    this.$emit('data-load', this.data)

                    this.loaded = true
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        save() {

            this.$refs.Tabs.validate()
                .then(valid => {

                    if (!valid) return

                    this.setLoading()

                    this.repositories.parametrizacao.store(this.prepareData())
                        .then(() => {

                            this.$emit('save')
                            this.showSaveNotification()
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
        prepareData() {

            const data = this.clone({
                requisicao: this.data.requisicao.model,
                controleEstoque: this.data.controleEstoque.model,
                dispensacaoMateriais: this.data.dispensacaoMateriais.model,
                estoque: this.data.estoque.model,
                portalDivulgacao: this.data.portalDivulgacao.model,
            })

            data.dispensacaoMateriais.grupos = data.dispensacaoMateriais.grupos.filter(grupo => grupo.dispensar || grupo.materiais.some(material => material.dispensar))

            data.controleEstoque.centrosCusto = data.controleEstoque.centrosCusto
                .filter(cc => cc.grupos.length > 0)
                .map(centroCusto => ({
                    id: centroCusto.id,
                    grupos: centroCusto.grupos.filter(g => g.permiteControlar).map(grupo => ({
                        id: grupo.id,
                        subgrupos: grupo.subgrupos.filter(sg => sg.permiteControlar).map(sg => sg.id)
                    }))
                }))

            data.portalDivulgacao.portalCentrosCusto = data.portalDivulgacao.portalCentrosCusto
                .filter(cc => cc.grupos.length > 0)
                .map(centroCusto => ({
                    id: centroCusto.id,
                    grupos: centroCusto.grupos.filter(g => g.permiteControlar).map(grupo => ({
                        id: grupo.id,
                         materiais: (grupo.materiais || []).filter(m => m.permiteControlar).map(materiais => ({
                            id: materiais.id,
                        })),
                        subgrupos: grupo.subgrupos.filter(sg => sg.permiteControlar).map(sg => sg.id)
                    }))
                }))

            const estoque = { centrosCusto: [] }

            data.estoque.centrosCusto.filter(cc => cc.grupos.length > 0).forEach(centroCustoData => {

                const centroCusto = {
                    id: centroCustoData.id,
                    materiais: []
                }

                centroCustoData.grupos.forEach(grupo => grupo.materiais
                    .forEach(material => centroCusto.materiais.push({
                        id: material.id,
                        estoqueMinimo: isNaN(parseInt(material.estoqueMinimo))
                            ? null : parseInt(material.estoqueMinimo),
                        estoqueMaximo: isNaN(parseInt(material.estoqueMaximo))
                            ? null : parseInt(material.estoqueMaximo),
                    }))
                )

                estoque.centrosCusto.push(centroCusto)
            })

            data.estoque = estoque

            return this.camelObjectKeysToSnakeRecursive(data)
        }
    },
    mixins: [object, stringCase, repository, error]
}
</script>